// extracted by mini-css-extract-plugin
export default {"container":"VXaMz","stickWrap":"k3SQS","wrapperFacelift":"cj7AD"};